import React from 'react';
import styled from 'styled-components';

type PackagedWeightProps = {
  packageOptions: {
    packageQuantity: number;
    option: string;
  }[];
  selectedOption: string;
};

export const PackagedWeight = ({ packageOptions, selectedOption }: PackagedWeightProps): JSX.Element | null => {
  const baseOption = packageOptions[0]?.option;

  const prepackQuantity = packageOptions.find((option) => option.option === selectedOption)?.packageQuantity ?? 1;

  if (prepackQuantity === 1 || !baseOption) {
    return null;
  }

  return (
    <Wrapper>
      (x{prepackQuantity}) packages of {baseOption}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  color: #121516;
  font-size: 14px;
  margin-top: 12px;
`;
